import { render, staticRenderFns } from "./Tournament2023.vue?vue&type=template&id=5f48c9b6&scoped=true"
import script from "./Tournament2023.vue?vue&type=script&lang=js"
export * from "./Tournament2023.vue?vue&type=script&lang=js"
import style0 from "./Tournament2023.vue?vue&type=style&index=0&id=5f48c9b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48c9b6",
  null
  
)

export default component.exports